<div class="d-flex align-items-center justify-content-end comparable-filter-bar">
    <div class="search-field">
        <mat-form-field class="mat-form-field-fluid">
            <input matInput [formControl]="searchControl" placeholder="Search this list" />
        </mat-form-field>
    </div>

    <button mat-icon-button type="button" [matTooltip]="'Filter'" (click)="onClickFilter()">
        <mat-icon [matBadge]="activeCount" [matBadgeHidden]="activeCount == 0" matBadgeSize="small"
            matBadgeColor="accent">filter_list</mat-icon>
    </button>

    <button mat-stroked-button type="button" color="warn" (click)="onClickReset()">
        Reset
    </button>

    <mat-spinner *ngIf="loading" diameter="18" class="ml-2"></mat-spinner>
</div>
